import _isEmpty from "lodash/isEmpty";
import { IChapter, IChapterListPageTypes, IVolume } from "./interfaces";

const _reverse = (list: any[]) => [...list].reverse();

interface IGenerateListQueryTypes
  extends Pick<
    IChapterListPageTypes,
    "bookInfo" | "volumeItems" | "curReadChapter"
  > {
  revert: boolean;
  currentChapter?: IChapter;
}

interface IPrivilegeCard {
  isPrivilegeCard: boolean;
}

export type IRenderItem = IChapter | IVolume | IPrivilegeCard;
/**
 * 章节列表 => 渲染列表
 * @param data
 * @param revert
 * @param currentChapter
 * @returns {Array}
 */
export const generateList = ({
  volumeItems,
  bookInfo,
  curReadChapter,
  revert,
}: IGenerateListQueryTypes): {
  list: IRenderItem[];
  curCatalogIndex?: number;
} => {
  const list = [] as IRenderItem[];
  if (_isEmpty(volumeItems)) {
    return { list };
  }
  (revert ? _reverse(volumeItems) : volumeItems).forEach(
    ({ volumeId, volumeName, chapterItems }) => {
      const newChapterItems = chapterItems.filter(
        // noArchive = 1 代表是来自于 Google robot 的回源
        (item: IChapter) => item?.chapterLevel == 0 || item?.noArchive === 1
      );
      if (newChapterItems.length > 0) {
        if (volumeId) {
          list.push({
            isVolume: true,
            volumeId,
            volumeName,
          });
        }
        (revert ? _reverse(newChapterItems) : newChapterItems).forEach(
          (chapterItem: IChapter) => {
            list.push({ ...chapterItem });
          }
        );
      }
    }
  );
  // 如果有特权提示，则加上特权提示
  // const { hasPrivilege } = bookInfo;
  // if (hasPrivilege === 1) {
  //   if (revert) {
  //     list.unshift({ isPrivilegeCard: true });
  //   } else {
  //     list.push({ isPrivilegeCard: true });
  //   }
  // }

  let curCatalogIndex = 0;
  if (curReadChapter) {
    curCatalogIndex = list.findIndex(
      (chapter: IRenderItem) =>
        "chapterId" in chapter && chapter.chapterId === curReadChapter
    );
  }
  return {
    list,
    curCatalogIndex,
  };
};

export const getTDK = (
  bookName: string,
  desc: string
): {
  title: string;
  keywords: string;
  description: string;
} => {
  return {
    title: `${bookName} Novel Read Free`,
    keywords: `${bookName}, novel, read novel, free novel`,
    description: `Read ${bookName} light novel. ${desc
      .replace(/[\r]?\n/g, "")
      .slice(0, 250)}...`,
  };
};
